import { alpha, Theme } from '@mui/material';

export default {
    wrapper: {
        width: '360px',
        ml: 3,
        flexShrink: 0,
        position: 'relative',
        '@container chartContainer (width < 600px)': {
            '&': {
                width: '100%',
                ml: 0,
                zIndex: 1,
                height: '100%',
                backgroundColor: (theme: Theme) => theme.palette.background.default,
            },
        },
        // Report KPI-chart summary gets its own card chrome (border/radius/margins) per Figma,
        // instead of the borderless layout the metric viewer/tile preview use.
        '&.summary--report': {
            ml: '10px',
            mt: 2,
            mr: 2,
            mb: 2,
            border: '1px solid',
            borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.16),
            borderRadius: '3px',
            overflow: 'hidden',
        },
    },
    scrollContainer: {
        '.summary--default &, .summary--report &': {
            maxHeight: '100%',
            overflow: 'auto',
            position: 'absolute',
            width: '100%',
        },
    },
    contentHolder: {
        position: 'relative',
        '.summary--default &': {
            mb: 2,
            borderLeft: '1px solid',
            borderBottom: '1px solid',
            borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        },
        '.summary--report &': {
            minHeight: '100%',
        },
    },
    closeIconHandler: {
        display: 'flex',
        alignItems: 'center',
        color: 'text.primary',
        position: 'absolute',
        right: '6px',
        top: '5px',
        zIndex: 1,
    },
    closeIcon: {
        '&:hover': {
            opacity: 0.65,
            cursor: 'pointer',
        },
    },
};
